function getOutOfStockForm(formId) {
    if (formId) {
        const scopedForm = document.querySelector(`[data-out-of-stock-form-ref="${CSS.escape(formId)}"]`);
        if (scopedForm) return scopedForm;
    }
    return document.getElementById('out-of-stock-form');
}

document.addEventListener('variant:change', function(event) {
    const variant = event.detail.variant;

    if (!variant) return;
    const outOfStockForm = getOutOfStockForm(event.detail.formId);
    if (!outOfStockForm) return;

    const variantInput = outOfStockForm.querySelector('input[name="variant_id"]');
    const sizeInput = outOfStockForm.querySelector('input[name="size"]');
    const colorInput = outOfStockForm.querySelector('input[name="color"]');

    // Guard against missing inputs
    if (!variantInput || !sizeInput || !colorInput) return;

    variantInput.value = variant.id;
    colorInput.value = variant.option1;
    sizeInput.value = variant.option2;

    if (!variant.available) {
        // Show the out-of-stock form
        outOfStockForm.classList.remove('hide');
    } else {
        // Hide the out-of-stock form
        outOfStockForm.classList.add('hide');
    }
});

// Alien/bundle PDPs (assets/alien-product.js) replace the Stretch variant picker and don't emit
// `variant:change`. The selected variant can belong to any child product, so product_id is updated too.
document.addEventListener('alien:variant-change', function(event) {
    const detail = event.detail;

    if (!detail || !detail.variantId) return;
    const outOfStockForm = getOutOfStockForm(detail.formId);
    if (!outOfStockForm) return;

    const productInput = outOfStockForm.querySelector('input[name="product_id"]');
    const variantInput = outOfStockForm.querySelector('input[name="variant_id"]');
    const sizeInput = outOfStockForm.querySelector('input[name="size"]');
    const colorInput = outOfStockForm.querySelector('input[name="color"]');

    // Guard against missing inputs
    if (!variantInput || !sizeInput || !colorInput) return;

    if (productInput && detail.productId) productInput.value = detail.productId;
    variantInput.value = detail.variantId;
    colorInput.value = detail.color;
    sizeInput.value = detail.size;

    outOfStockForm.classList.toggle('hide', detail.available);

    // Reset a previous submission when the selection changes
    outOfStockForm.querySelector('[data-notify-success]')?.classList.add('hide');
    outOfStockForm.querySelector('[data-notify-error]')?.classList.add('hide');
    const emailInput = outOfStockForm.querySelector('[data-email-input]');
    emailInput?.classList.remove('form-input-error');
    emailInput?.removeAttribute('aria-invalid');
});
